export { WorkOrderContext, withWorkOrderContext } from './context';
import WorkOrderContextProvider from './WorkOrderContextProvider';

export default WorkOrderContextProvider;